import React from 'react';

const EmptyState = () => {
  return <div className="text-sm text-slate-500 dark:text-slate-400">No details available.</div>;
};

export default React.memo(EmptyState);
